import { auth, database, messaging } from 'helpers/firebase'
import { PUBLIC_VAPID_KEY } from 'constants/firebase'

messaging.usePublicVapidKey(PUBLIC_VAPID_KEY)

export const initMessaging = () => {
  messaging
    .requestPermission()
    .then(function() {
      console.log('Notification permission granted.')

      // Get Instance ID token. Initially this makes a network call, once retrieved
      // subsequent calls to getToken will return from cache.
      messaging
        .getToken()
        .then(function(currentToken) {
          if (currentToken) {
            console.log('Token retrieved:', currentToken)
            database.ref(`users/${auth.currentUser.uid}`).update({
              cloudMessagingToken: currentToken
            })
          } else {
            // Show permission request.
            console.log(
              'No Instance ID token available. Request permission to generate one.'
            )
            // Show permission UI.
            initMessaging()
          }
        })
        .catch(function(err) {
          console.log('An error occurred while retrieving token. ', err)
        })

      // Callback fired if Instance ID token is updated.
      messaging.onTokenRefresh(function() {
        messaging
          .getToken()
          .then(function(refreshedToken) {
            database.ref(`users/${auth.currentUser.uid}`).update({
              cloudMessagingToken: refreshedToken
            })
          })
          .catch(function(err) {
            console.log('Unable to retrieve refreshed token ', err)
          })
      })
    })
    .catch(function(err) {
      console.log('Unable to get permission to notify.', err)
    })
}

// window.activeToken = null

// const updateToken = callback => {
//   if (auth.currentUser) {
//     messaging.getToken().then(currentToken => {
//       console.log('Token retrieved:', currentToken)
//       database.ref(`users/${auth.currentUser.uid}`).update({
//         cloudMessagingToken: currentToken
//       })
//       if (process.env.NODE_ENV === 'development') {
//         window.activeToken = currentToken
//       }
//       callback(currentToken)
//     })
//   }
// }

// export const initMessaging = callback =>
//   new Promise(res => {
//     messaging.requestPermission().then(() => {
//       console.log('Notification permission granted.')
//       // Get Instance ID token. Initially this makes a network call, once retrieved
//       // subsequent calls to getToken will return from cache.
//       messaging.onTokenRefresh(() => updateToken(callback))
//       updateToken(firstToken => {
//         callback(firstToken)
//         res(firstToken)
//       })
//     })
//   })



// WEBPACK FOOTER //
// ./src/helpers/notifications.js